import {
  HeadingGroup,
  ModalLayout,
  NavGroup,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  // Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import useReassign from "./useReassign";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../Global/OrderColumn";
import Filter from "./Filter";
import Style from "./recheck.module.scss";
import RecheckDetails from "./Details/ReassignDetails";
import { Link } from "react-router-dom";
import StockReceipt from "./StockReceipt";
import RecheckOfficeSlip from "./RecheckOfficeSlip/RecheckOfficeSlip";
import ReassignModel from "./Details/ReassignDetails";
import StockUpdateModel from "./StockUpdateModel";
import ExcelUpload from "./ExcelUpload";
// import ReissueDetails from "./Details/Reissue";
import {Table} from "../../Global/Table";

const Reassign = () => {
  const {
    tableFields,
    activeTab,
    reassignList,
    isFetching,
    reassignState,
    filterShow,
    showEditModal,
    tabNavs,
    paginationOptions,
    StockReceiptRef,
    recheckOfficeSlipRef,
    inputData,
    getRow,
    refetch,
    handleSort,
    handleClose,
    handleSearch,
    setFilterShow,
    handlePageSize,
    handlePagination,
    handleClearClick,
    handleEditColumnsClick,
    updateRecheckTableData,
    handleReassignModal,
    handleExcelFileDownload,
    recheckList,
    handleStockUpdate,
    handleExcelUploadClick,
    handleExcelUploadModalClose,
  } = useReassign();

  return (
    <>
      <HeadingGroup title={"Reassign"} className={`pro-mb-4`} />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <div className={`${Style.main_container}`}>
          <NavGroup navigations={tabNavs} type={"type-2"} Link={Link} />
        </div>
        <div className="row gx-2">
          <div className="col-auto">
            <div className="search-wrap xl">
              <SearchFilters
                onSearchInput={handleSearch}
                showActions={true}
                showFilters={true}
                searchInputProps={{ value: inputData,placeholder: activeTab === "recheck" ? "Search GLI Number , Supplier " : "Search GLI Number , LOT Number , Supplier , Shop" }}
                handleActionClick={handleEditColumnsClick}
                // loading={isLoading}
                SearchIcon={
                  <span className="material-symbols-outlined"> search </span>
                }
                handleClear={handleClearClick}
                showDateRange={false}
              />
            </div>
          </div>
          {/* <div className="col-auto">
            <button
              className={`pro-btn pro-btn-outline pro-h-100  pro-items-center pro-px-5 ${Style.filter_btn}`}
              onClick={() => setFilterShow(true)}
            >
              <span className="material-symbols-outlined">tune</span>
              <span>Filter</span>
            </button>
          </div> */}
        </div>
        <Table
          multiSelect={false}
          data={
            activeTab === "orders"
              ? reassignList?.data?.data || []
              : recheckList?.data?.data || []
          }
          uniqueID={"_id"}
          fields={tableFields}
          SortIcon={<FaSort />}
          clear={reassignState.clearSelection}
          editIcon={
            <span className="material-symbols-outlined">change_circle</span>
          }
          deleteIcon={
            activeTab === "orders" ? (
              <span className="material-symbols-outlined">change_circle</span>
            ) : (
              <span className="material-symbols-outlined">download</span>
            )
          }
          handleSort={handleSort}
          getRow={getRow}
          loading={isFetching}
          perpage={
            activeTab === "orders"
              ? reassignList?.currentPageSize
              : recheckList?.currentPageSize
          }
          assignable={activeTab !== "orders" ? true : false}
          assignText={"Excel Upload"}
          assignIcon={<span className="material-symbols-outlined">upload</span>}
          handleAssign={handleExcelUploadClick}
          editable={true}
          editText={"Reassign"}
          deleteText={
            activeTab === "orders" ? "Stock Update" : "Excel Download"
          }
          handleEdit={handleReassignModal}
          handleDelete={
            activeTab === "orders" ? handleStockUpdate : handleExcelFileDownload
          }
          deletable={true}
          showCheckBox={true}
          
          tabFilter = {true}
          stickyActionBtns = {true}
          //  extraClasssName="table-wrapper tab-tbl-h"
        />

        {activeTab === "orders" && reassignList?.data?.data?.length > 0 && (
          <Pagination
            currentPage={reassignState?.currentPage}
            totalPageCount={Math.ceil(
              reassignList?.data?.total_count / reassignState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        {activeTab === "recheck" && recheckList?.data?.data?.length > 0 && (
          <Pagination
            currentPage={reassignState?.currentRecheckPage}
            totalPageCount={Math.ceil(
              recheckList?.data?.total_count /
                reassignState?.currentRecheckPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        {/* <OffCanvasLayout
          show={reassignState?.showAddRecheckModal}
          handleClose={handleClose}
          title="Recheck"
        >
          <RecheckDetails refetch={refetch} />
        </OffCanvasLayout> */}

        <ModalLayout
          show={reassignState.excelUploadModal}
          handleClose={handleExcelUploadModalClose}
          title={`Upload Excel`}
          closeIcon={<span className="material-symbols-outlined"> close </span>}
        >
          <div className="pro-m-5">
            <ExcelUpload />
          </div>
        </ModalLayout>

        <ModalLayout show={showEditModal} handleClose={handleEditColumnsClick}>
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={
                activeTab === "orders"
                  ? reassignList?.data?.fields
                  : recheckList?.data?.fields
              }
              moduleId={
                activeTab === "orders"
                  ? reassignList?.data?.module_id
                  : recheckList?.data?.module_id
              }
              updateData={updateRecheckTableData}
            />
          </div>
        </ModalLayout>
        <ModalLayout
          show={reassignState?.showReassignModal}
          handleClose={() => handleClose()}
          title="Reassign"
        >
          <ReassignModel refetch={refetch} activeTab={activeTab} />
        </ModalLayout>
        <ModalLayout
          show={reassignState?.showDeleteModal}
          handleClose={() => handleClose()}
          title="Stock Update"
        >
          <StockUpdateModel refetch={refetch} />
        </ModalLayout>
        {/* <OffCanvasLayout
          show={filterShow}
          title={"Filter"}
          handleClose={() => {
            setFilterShow(false);
          }}
          closeIcon={<span className="material-symbols-outlined">close</span>}
        >
          <Filter setShowform={setFilterShow} />
        </OffCanvasLayout> */}
      </div>
      {/* <div className={Style.print}>
        <StockReceipt stockPrintRef={StockReceiptRef} />
        <RecheckOfficeSlip recheckOfficeSlipRef={recheckOfficeSlipRef} />
      </div> */}
    </>
  );
};

export default Reassign;
